// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.0035 2.00195L11.0035 1.99805L11.0014 3.08266C8.48696 3.50372 6.50245 5.48865 6.08203 8.00333H17.9172C17.497 5.48984 15.5142 3.5056 13.0014 3.08326L13.0035 2.00195Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 10H2V12H3V22H8V16H16V22H21V12H22V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 22V18H14V22H10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mosque-filled')
export default class MosqueFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mosque-filled',
    }
  }
}
